import React, { useContext, useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import BankAndTaxAIF from "../../../components/page-components/investment-process-aif/bank-and-tax-aif";
import InvestmentAmountAIF from "../../../components/page-components/investment-process-aif/investment-amount-aif";
import { TextField, Typography, Box } from "@mui/material";
import { Grid, Text, Divider, useTheme, Spacer, Button, Card, Page } from "@geist-ui/core";
import { motion } from "framer-motion";

import { InvestmentSurveyAIF } from "../../../components/page-components/investment-process-aif/investment-survey-aif";
import MultistepForm from "../../../components/vertical-multistep-form/multistep-form";
import MultistepFormBody, {
  MultistepFormBodyV2,
} from "../../../components/vertical-multistep-form/multistep-form-body";
import MultistepFormNavigation, {
  MultistepFormNavigationV2,
} from "../../../components/vertical-multistep-form/multistep-form-navigation";
import MultistepFormStep, {
  MultistepFormStepV2,
} from "../../../components/vertical-multistep-form/multistep-form-step";
import VerticalStepperGeist from "../../../components/vertical-multistep-form/vertical-stepper-geist";
import { Campaign, Fund } from "../../../types/fund_types";
import {
  CreateInvestmentDTO,
  Investment,
  INVESTMENT_STATE,
  SelfDisclosure,
} from "../../../types/investment_types";
import LoadingScreen from "../../../components/loading-screen";
import {
  PrimaryButtonV2,
  SecondaryButton,
  SecondaryButtonV2,
} from "../../../components/input-elements/buttons";
import MultistepFormButtons from "../../../components/vertical-multistep-form/multistep-form-buttons";
import Footer from "../../../template/footer";
import FooterV2 from "../../../template/footer-v2";
import { PersonalData } from "./subpages/personal-data";
import InvestmentAmount from "./subpages/investment-amount";
import API_CLIENT from "../../../utility/api-client";
import queryString from "query-string";
import { AppContext } from "../direct-router";
import { MatchingDTO, USER_STATE } from "../../../types/generic_types";
import { SurveyFull } from "./subpages/survey";
import { useAuth0 } from "@auth0/auth0-react";
import TagManager from "react-gtm-module";
import { sha256 } from "js-sha256";
import BankAndTaxFull from "./subpages/bank-tax";
import { INVESTOR_TYPE } from "../../../types/onboarding_types";
import theme from "../../../theme";
import Summary from "./subpages/summary";
import Guide from "./subpages/guide";
import DocumentBox, {
  DocumentBoxWide,
} from "../../../components/data-display/document-box";
import PdfPreviewer from "../dashboard/pdf-preview-document";
import DataProtection from "./subpages/data-protection";
import { DocumentBadge } from "./components/document-badge";
import { FileText } from "@geist-ui/icons";
import { PdfViewerGeistModal } from "./components/pdf-viewer-geist-modal";

interface InvestmentContextFull {
  fund: Fund | null;
  campaign: Campaign | null;
  investment: Investment | null;
  setInvestment: (investment: Investment | null) => void;
  last_investment: Investment | null | undefined;
  amount: number | null;
  setAmount: (n: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  setLoading: (loading: boolean) => void;
  setForceRedraw: () => void;
}

export enum INVESTMENTPROCESS_STEP {
  ERROR = -1,
  AMOUNT = 0,
  PERSONAL_DATA = 1,
  SURVEY = 2,
  BANK = 3,
  DATA_PROTECTION = 4,
  SUMMARY = 5,
  SUCCESS = 6,
}

export const InvestmentContextFull = React.createContext<InvestmentContextFull>(
  {
    fund: null,
    campaign: null,
    investment: null,
    setInvestment: () => null,
    last_investment: null,
    amount: null,
    setAmount: () => null,
    nextStep: () => null,
    prevStep: () => null,
    setLoading: () => null,
    setForceRedraw: () => null,
  }
);

export default function InvestmentProcessFull() {
  const { isAuthenticated } = useAuth0();
  const app_context = useContext(AppContext);
  const user = app_context.user;
  const [loading, setLoading] = useState(true);
  const [investment, setInvestment] = useState<Investment | null>(null);
  const [investment_loading, setInvestmentLoading] = useState(true);
  const [active_step, setActiveStep] = useState(INVESTMENTPROCESS_STEP.AMOUNT);
  const [blockTo, setBlockTo] = useState(0);
  const [fund, setFund] = useState<Fund | null>(null);
  const [fund_loading, setFundLoading] = useState(true);
  const [campaign, setCampaign] = useState<Campaign | null>(null);
  const theme = useTheme();
  
  const [previewDoc, setPreviewDoc] = useState<{url: string, name: string} | null>(null);

  const [highestStep, setHighestStep] = useState(1);
  const [last_investment, setLastInvestment] = useState<Investment | null>();
  const [last_investment_loading, setLastInvestmentLoading] = useState(false);
  const [force_redraw, setForceRedraw] = useState(true);
  const [personal_step_dirty, setPersonalStepDirty] = useState(false);
  const [bank_tax_step_dirty, setBankTaxStepDirty] = useState(false);
  const [data_protection_step_dirty, setDataProtectionStepDirty] =
    useState(false);
  var investment_in_creation = false;

  //queries
  const queries = queryString.parse(window.location.search);
  const campaign_id = queries.campaign ? queries.campaign.toString() : "";
  const fund_id = queries.fund ? queries.fund.toString() : "";
  const investment_id = queries.investment_id ? queries.investment_id.toString() : "";

  const steps = [
    "Anlagebetrag",
    "Persönliche Daten",
    "Kenntnisse & Erfahrungen",
    "Bank & Steuer",
    "Datenschutz",
    "Zusammenfassung",
  ];

  let ls_amount: number | null = Number(
    localStorage.getItem(`investment-amount-${campaign_id}`)
  );
  if (ls_amount == 0) ls_amount = null;

  const [amount, setAmount] = useState<number | null>(ls_amount);

  const invalidateDirtySteps = () => {
    setPersonalStepDirty(false);
    setBankTaxStepDirty(false);
  };

  useEffect(() => {
    console.log("use effect");

    API_CLIENT.getFundNoAuth(
      fund_id,
      (fund) => {
        setFund(fund);
        var campaign = fund.cashlinkCampaigns.find(
          (campaign) => campaign.cashlinkId == campaign_id
        );
        if (campaign) {
          setCampaign(campaign);
        }
        setFundLoading(false);
      },
      (error) => console.log(error)
    );
    if (!isAuthenticated) {
      setInvestmentLoading(false);
      return;
    }
    API_CLIENT.getLastIncomingInvestment(
      app_context.token,
      user!.uid,
      (investment) => {
        setLastInvestment(investment);
        setLastInvestmentLoading(false);
      },
      () => {
        setLastInvestment(null);
        setLastInvestmentLoading(false);
        console.log("Init: No previous investment signed");
      }
    );
    API_CLIENT.getInvestmentsByCampaign(
      app_context.token,
      campaign_id,
      (investments: Investment[]) => {
        var activeInvestment = null;
        var commulatedInvestmentSize = 0;
        investments.forEach((investment) => {
          if (investment.state === INVESTMENT_STATE.PENDING) {
            activeInvestment = investment;
          }
          if (
            investment.state === INVESTMENT_STATE.ACCEPTED ||
            investment.state === INVESTMENT_STATE.WAITING_FOR_ACCEPTANCE ||
            investment.state === INVESTMENT_STATE.PAID ||
            investment.state === INVESTMENT_STATE.DELIVERED ||
            investment.state === INVESTMENT_STATE.KYC_PENDING ||
            investment.state === INVESTMENT_STATE.KYC_INVALID ||
            investment.state === INVESTMENT_STATE.KYC_INSUFFICIENT
          ) {
            commulatedInvestmentSize += investment.amount;
          }
        });
        console.log(activeInvestment);
        setInvestment(activeInvestment);
        setInvestmentLoading(false);
      },
      () => {
        setInvestment(null);
        //setInvestmentLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);

  useEffect(() => {
    console.log("use effect: amount changed");
    const cou = async () => {
      if (
        !investment_loading &&
        !fund_loading &&
        app_context.userState != null
      ) {
        createOrUpdateInvestment();
      }
    };
    cou();
  }, [amount]);

  useEffect(() => {
    const cou = async () => {
      if (user && !investment_loading) {
        console.log("create investment because no one exists");
        await createOrUpdateInvestment();
      }
    };
    cou();
    // if (
    //   fund &&
    //   campaign &&
    //   !investment_loading &&
    //   app_context.userState != null
    // ) {
    //   setLoading(false);
    // }
  }, [fund_loading, investment_loading, app_context.userState, user]);

  //this useEffect ensures that as soon as everything needed is loaded, the step is chosen
  useEffect(() => {
    if (
      !investment_loading &&
      !fund_loading &&
      app_context.userState != null &&
      !investment_in_creation
    ) {
      console.log("use effect: investment changed");
      //prevent choosing step to only force it once
      //if (amount != investment?.amount) return;
      chooseStep();
      setLoading(false);
    }
  }, [
    investment,
    investment_loading,
    fund_loading,
    app_context.userState,
    force_redraw,
    user,
    amount,
  ]);

  const chooseStep = () => {
    console.log("selecting step");
    console.log("personal step dirty: " + personal_step_dirty);
    let step = INVESTMENTPROCESS_STEP.AMOUNT;
    let highest_step = INVESTMENTPROCESS_STEP.AMOUNT;

    const user_legal =
      app_context.user?.investor_type == INVESTOR_TYPE.LEGAL_PERSON;
    const legal_person_missing =
      user?.legal_person == null || user.benefiting_persons.length == 0;
    const is_legal_onboarded =
      !(user_legal && legal_person_missing) || !user_legal;

    console.log(
      localStorage.getItem("investment-amount-" + campaign?.cashlinkId)
    );
    const is_personal_data =
      amount != null ||
      localStorage.getItem("investment-amount-" + campaign?.cashlinkId);
    const is_survey =
      is_personal_data &&
      (app_context.userState == USER_STATE.ONBOARDED_1 ||
        app_context.userState == USER_STATE.ONBOARDED_2) &&
      is_legal_onboarded &&
      investment?.legitimation_document != null;
    const is_survey_dirty = personal_step_dirty && is_survey;
    const is_bank_tax = is_survey && investment?.survey;
    const is_bank_tax_dirty = is_survey_dirty && investment?.survey;
    const is_data_protection =
      is_bank_tax &&
      user?.bank_account &&
      user?.taxInformation &&
      user?.taxInformation.tax_germany_only != null;
    const is_data_protection_dirty =
      is_bank_tax_dirty &&
      user?.bank_account &&
      user?.taxInformation &&
      user?.taxInformation.tax_germany_only != null;
    const is_summary =
      is_data_protection && investment.data_protection_no_sharing != null;
    const is_summary_dirty = bank_tax_step_dirty && is_summary;

    if (is_personal_data) {
      console.log("selecting step: amount is set");
      step = INVESTMENTPROCESS_STEP.PERSONAL_DATA;
      highest_step = INVESTMENTPROCESS_STEP.PERSONAL_DATA;
      setPersonalStepDirty(true);
    }
    if (is_survey) {
      console.log("selecting step: personal data are given");
      highest_step = INVESTMENTPROCESS_STEP.SURVEY;
    }
    if (is_survey_dirty) {
      console.log("selecting step: personal data are dirty");
      step = INVESTMENTPROCESS_STEP.SURVEY;
    }
    if (is_bank_tax) {
      console.log("selecting step: survey data are given");
      highest_step = INVESTMENTPROCESS_STEP.BANK;
      setBankTaxStepDirty(true);
    }
    if (is_bank_tax_dirty) {
      console.log("selecting step: survey data are dirty");
      step = INVESTMENTPROCESS_STEP.BANK;
    }
    if (is_data_protection) {
      console.log("selecting step: bank tax is given");
      highest_step = INVESTMENTPROCESS_STEP.DATA_PROTECTION;
    }
    if (is_data_protection_dirty) {
      console.log("selecting step: bank tax is given");
      step = INVESTMENTPROCESS_STEP.DATA_PROTECTION;
    }
    if (is_summary) {
      console.log("selecting step: bank data are given");
      highest_step = INVESTMENTPROCESS_STEP.SUMMARY;
    }
    if (is_summary_dirty) {
      console.log("selecting step: bank data are dirty");
      step = INVESTMENTPROCESS_STEP.SUMMARY;
    }

    switch (step) {
      case INVESTMENTPROCESS_STEP.SURVEY:
        break;
    }

    if (user_legal) {
    }

    setStep(step, highest_step);
  };

  const setStep = (
    step: INVESTMENTPROCESS_STEP,
    highest_step: INVESTMENTPROCESS_STEP
  ) => {
    setActiveStep(step);
    setHighestStep(highest_step);
  };

  const nextStep = () => {
    let next_step = INVESTMENTPROCESS_STEP.ERROR;
    switch (active_step) {
      case INVESTMENTPROCESS_STEP.AMOUNT:
        next_step = INVESTMENTPROCESS_STEP.PERSONAL_DATA;
        break;
      case INVESTMENTPROCESS_STEP.PERSONAL_DATA:
        next_step = INVESTMENTPROCESS_STEP.SURVEY;
        break;
      case INVESTMENTPROCESS_STEP.SURVEY:
        next_step = INVESTMENTPROCESS_STEP.BANK;
        break;
      case INVESTMENTPROCESS_STEP.BANK:
        next_step = INVESTMENTPROCESS_STEP.DATA_PROTECTION;
        break;
      case INVESTMENTPROCESS_STEP.DATA_PROTECTION:
        next_step = INVESTMENTPROCESS_STEP.SUMMARY;
        break;
      case INVESTMENTPROCESS_STEP.SUMMARY:
        next_step = INVESTMENTPROCESS_STEP.SUCCESS;
        // Handle the logic for the final step
        break;
      default:
        break;
    }
    var highest_step = highestStep;
    if (next_step > highestStep) highest_step = next_step;
    setStep(next_step, highest_step);
  };

  const prevStep = () => {
    let prev_step = INVESTMENTPROCESS_STEP.ERROR;
    switch (active_step) {
      case INVESTMENTPROCESS_STEP.SUCCESS:
        prev_step = INVESTMENTPROCESS_STEP.SUMMARY;
        break;
      case INVESTMENTPROCESS_STEP.SUMMARY:
        prev_step = INVESTMENTPROCESS_STEP.DATA_PROTECTION;
        break;
      case INVESTMENTPROCESS_STEP.DATA_PROTECTION:
        prev_step = INVESTMENTPROCESS_STEP.BANK;
        break;
      case INVESTMENTPROCESS_STEP.BANK:
        prev_step = INVESTMENTPROCESS_STEP.SURVEY;
        break;
      case INVESTMENTPROCESS_STEP.SURVEY:
        prev_step = INVESTMENTPROCESS_STEP.PERSONAL_DATA;
        break;
      case INVESTMENTPROCESS_STEP.PERSONAL_DATA:
        prev_step = INVESTMENTPROCESS_STEP.AMOUNT;
        break;
      default:
        break;
    }
    setStep(prev_step, highestStep);
  };

  const createOrUpdateInvestment = async () => {
    if (investment_loading) return;
    console.log("create or update investment");
    //check if user is logged in
    //   ==> if yes, continue
    //   ==> if not, do nothing
    if (!isAuthenticated) {
      console.log("user is not logged in");
      chooseStep();
      setLoading(false);
      return;
    }
    invalidateDirtySteps();
    //check if an investment exists
    if (investment != null) {
      console.log("investment already exists");
      console.log("checking, if amount changed");
      if (investment.amount != amount) {
        if (amount == null) return;
        setPersonalStepDirty(false);
        setBankTaxStepDirty(false);
        console.log("updating investment");
        var sd: SelfDisclosure = {
          self_disclosure_monthly_income: true,
          self_disclosure_net_worth_100k: true,
        };
        var createInvestmentDTO: CreateInvestmentDTO = {
          selfDisclosure: sd,
          couponCode: null,
          investmentKey: null,
        };
        investment_in_creation = true;
        API_CLIENT.putInvestmentAmount(
          createInvestmentDTO,
          app_context.token,
          amount,
          investment.id,
          (investment) => {
            console.log("updated investment");
            investment_in_creation = false;
            setInvestment(investment);
          },
          (error) => console.log(error),
          () => {},
          () => {}
        );
      } else {
        console.log("amount didnt change");
      }
    } else {
      console.log("investment hasen't been created yet");
      console.log("creating investment");

      var sd: SelfDisclosure = {
        self_disclosure_monthly_income: true,
        self_disclosure_net_worth_100k: true,
      };
      var createInvestmentDTO: CreateInvestmentDTO = {
        selfDisclosure: sd,
        couponCode: null,
        investmentKey: null,
      };
      if (amount == null || campaign == null) return;
      investment_in_creation = true;
      API_CLIENT.postInvestmentAmount(
        createInvestmentDTO,
        app_context.token,
        amount,
        campaign.cashlinkId,
        (investment) => {
          investment_in_creation = false;
          console.log("successfully created investment");
          var uData = app_context.matchingData;

          // var mData: MatchingDTO = {
          //   event: "CustomizeProduct",
          //   eventId: investment.id,
          //   sourceUrl: window.location.href,
          //   em: uData?.em,
          //   ph: uData?.ph,
          //   fn: uData?.fn,
          //   ln: uData?.ln,
          //   product: fund?.name,
          //   focus: fund?.fokus,
          //   type: fund?.type,
          //   value: investment.amount.toString(),
          //   currency: "EUR",
          // };

          //API_CLIENT.postMatching(app_context.token, mData);

          // TagManager.dataLayer({
          //   dataLayer: {
          //     event: "customize-product",
          //     event_id: investment.id,
          //     first_name: app_context.user?.natural_person.forename,
          //     last_name: app_context.user?.natural_person.surname,
          //     phone: uData?.ph,
          //     email: sha256(app_context.userEmail),
          //     product: fund?.name,
          //     focus: fund?.fokus,
          //     type: fund?.type,
          //     value: investment.amount,
          //     currency: "EUR",
          //   },
          // });
          // (window as any).dataLayer.push({
          //   event: "investment-created",
          //   "investment-amount": investment.amount,
          // });

          setInvestment(investment);
          setInvestmentLoading(false);
        },
        (error) => console.log(error),
        () => {},
        () => {}
      );
    }
    console.log("investment updated or created");

    //   ==> if yes, check if amount changed and update it regardingly
    //   ==> if not, create a new one
  };

  const renderStep = (step: number) => {
    switch (step) {
      case INVESTMENTPROCESS_STEP.AMOUNT:
        return <InvestmentAmount />;
      case INVESTMENTPROCESS_STEP.PERSONAL_DATA:
        return <PersonalData back={prevStep} next={nextStep} />;
      case INVESTMENTPROCESS_STEP.SURVEY:
        return <SurveyFull back={prevStep} next={nextStep} />;
      case INVESTMENTPROCESS_STEP.BANK:
        return <BankAndTaxFull back={prevStep} next={nextStep} />;
      case INVESTMENTPROCESS_STEP.DATA_PROTECTION:
        return <DataProtection back={prevStep} next={nextStep} />;
      case INVESTMENTPROCESS_STEP.SUMMARY:
        return <Summary back={prevStep} next={nextStep} />;
      default:
        return <InvestmentAmount />;
    }
  };

  return (
    <InvestmentContextFull.Provider
      value={{
        fund,
        campaign,
        investment,
        amount,
        last_investment,
        setAmount,
        setInvestment,
        nextStep,
        prevStep,
        setLoading: (l) => setLoading(l),
        setForceRedraw: () => {
          chooseStep();
          setLoading(false);
        },
      }}
    >
      <PdfViewerGeistModal 
        isOpen={!!previewDoc}
        url={previewDoc?.url || null}
        name={previewDoc?.name || null}
        onClose={() => setPreviewDoc(null)}
      />

      <div style={{ background: '#FBFBFB', minHeight: '100vh', width: '100%', overflowX: 'hidden' }}>
        <Page 
            width="100%" 
            style={{ 
                padding: 'clamp(24px, 5vw, 60px) 0 100px 0', 
                position: 'relative',
                maxWidth: '1200px',
                margin: '0 auto'
            }}
        >
          {/* Institutional Background Texture */}
          <div style={{ 
              position: 'absolute', 
              inset: 0, 
              backgroundImage: 'radial-gradient(#E5E5E5 0.5px, transparent 0.5px), radial-gradient(#E5E5E5 0.5px, transparent 0.5px)',
              backgroundSize: '40px 40px',
              backgroundPosition: '0 0, 20px 20px',
              opacity: 0.1,
              pointerEvents: 'none',
              zIndex: 0
          }}></div>

          <Page.Content style={{ padding: '0 clamp(16px, 4vw, 40px) 100px', position: 'relative', zIndex: 1 }}>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}>
              
              {/* Header Section */}
              <div style={{ display: "flex", flexDirection: "column", gap: "24px", marginBottom: "48px" }}>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                    <div className="flex flex-col gap-2">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{ width: '10px', height: '1px', background: '#000' }}></div>
                            <Text span style={{ 
                                fontFamily: "'JetBrains Mono', monospace", 
                                fontSize: '10px', 
                                letterSpacing: '0.1em', 
                                color: '#888',
                                textTransform: 'uppercase'
                            }}>
                                SECURE INVESTMENT / {investment_id?.slice(0, 8)}
                            </Text>
                        </div>
                        <Text h2 style={{ 
                            fontFamily: '"Nunito Sans", sans-serif', 
                            fontWeight: 900, 
                            fontSize: 'clamp(28px, 5vw, 48px)', 
                            margin: 0, 
                            letterSpacing: '-0.04em',
                            lineHeight: 1.1,
                            textTransform: 'uppercase'
                        }}>
                          {fund?.name}
                        </Text>
                    </div>

                    {/* Document Quick Access */}
                    <div className="flex items-center gap-2 flex-wrap">
                        {campaign?.documents.map((doc) => (
                            <button
                                key={doc.name}
                                onClick={() => setPreviewDoc({ url: doc.location, name: doc.name })}
                                className="px-4 py-2 rounded-full border border-gray-100 bg-white shadow-sm hover:shadow-md hover:border-black transition-all text-[11px] font-bold uppercase tracking-tight flex items-center gap-2"
                            >
                                <FileText size={12} />
                                {doc.name}
                            </button>
                        ))}
                    </div>
                </div>
              </div>

              {/* Main Workflow Area */}
              <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
                {/* NAVIGATION COLUMN */}
                <div className="lg:w-1/4">
                  <div className="sticky top-24">
                    <VerticalStepperGeist
                      loading={loading}
                      blockTo={blockTo}
                      alignTop
                      totalSteps={steps.length}
                      highestStep={highestStep}
                      onStepClick={(step: number) => {
                        if (step <= highestStep) setActiveStep(step);
                      }}
                      activeStep={active_step}
                      labels={steps}
                    />
                  </div>
                </div>

                {/* CONTENT COLUMN */}
                <div className="lg:w-3/4">
                  {loading ? (
                    <div className="flex items-center justify-center min-h-[400px]">
                        <LoadingScreen className="w-full" backgroundColor="transparent" />
                    </div>
                  ) : app_context.user?.investor_type === INVESTOR_TYPE.LEGAL_PERSON ? (
                    <div className="flex flex-col w-full items-center">
                        <Card width="100%" style={{ padding: 'clamp(24px, 5vw, 48px)', textAlign: 'center', border: '1px solid #000' }}>
                          <Text h3 style={{ marginBottom: '1.5rem', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>Juristische Person</Text>
                          <Text p style={{ color: '#666', fontSize: '1.1rem', marginBottom: '2rem' }}>
                            Leider ist eine direkte Online-Zeichnung für juristische Personen aktuell nicht möglich.
                          </Text>
                          <Text p style={{ marginBottom: '2.5rem', lineHeight: 1.6 }}>
                            Um über eine GmbH oder UG zu investieren, buchen Sie bitte ein Gespräch für die manuelle Abwicklung.
                          </Text>
                          <motion.button 
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            className="w-full py-5 rounded-full bg-black text-white font-black text-sm uppercase tracking-widest shadow-2xl"
                            onClick={() => window.open('https://meetings.hubspot.com/dat-le', '_blank')}
                          >
                            Termin vereinbaren
                          </motion.button>
                        </Card>
                    </div>
                  ) : (
                    <motion.div
                        key={active_step}
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                    >
                        {renderStep(active_step)}
                    </motion.div>
                  )}
                </div>
              </div>
            </motion.div>
          </Page.Content>
        </Page>
      </div>
    </InvestmentContextFull.Provider>
  );
}
/**
 *
 */
